import { Pie } from 'react-chartjs-2';

import { Chart, plugins, elements } from 'chart.js';
import {
  buildChartOptions,
  getTokenColor,
  groupAssetDistributionEntries,
  sumAssetDistributionEntries,
} from 'structure/capital-manager/utils/charts';
import { ChartLegend } from 'structure/capital-manager/components/ChartLedend';
import { useMemo } from 'react';
import { TokenTableRow } from 'structure/capital-manager/types';

// Register necessary components
Chart.register(
  elements.ArcElement,
  elements.LineElement,
  elements.PointElement,
  elements.BarElement,
  plugins.Title,
  plugins.Tooltip,
  plugins.Legend,
  plugins.SubTitle
);

interface AssetsOverviewChartProps {
  tokens: TokenTableRow[];
}

const OTHERS_COLOR = '#6B7280';

export const ChartAssetsOverview = (props: AssetsOverviewChartProps) => {
  const { tokens = [] } = props;

  const entriesBySymbol = useMemo(
    () =>
      sumAssetDistributionEntries(
        tokens.map((token) => ({
          label: token.symbol,
          value: token.balanceUsd,
        }))
      ),
    [tokens]
  );

  const allEntries = entriesBySymbol
    .filter((item) => item.value > 0)
    .sort((a, b) => b.value - a.value);

  const sortedEntries = groupAssetDistributionEntries(allEntries);

  const labels = sortedEntries.map((item) => item.label);
  const values = sortedEntries.map((item) => item.value);

  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Percentage',
        data: values.map((item) => Number(item.toFixed(2))),
        backgroundColor: labels.map((label, index) =>
          label === 'Others' ? OTHERS_COLOR : getTokenColor(label, index)
        ),
        hoverOffset: 15,
        borderWidth: 0,
      },
    ],
  };

  const options = buildChartOptions({
    title: 'Asset distribution',
  });

  return (
    <div className='flex flex-col items-center gap-4'>
      <Pie options={options} data={data} />
      <ChartLegend labels={labels} dataset={data.datasets[0]} />
    </div>
  );
};
